import { FC } from "react";
import AboutUsSection from "../sections/AboutUsSection";
import HeroSection from "../sections/HeroSection";
import MembershipsSection from "../sections/MembershipsSection";
import TrainersSection from "../sections/TrainersSection";
import HallsSection from "../sections/HallsSection";
import Footer from "../components/Footer";
import RulesSection from "../sections/RulesSection";

const MainPage: FC = () => {
    return (
        <main>
            <HeroSection />
            <AboutUsSection />
            <MembershipsSection />
            <TrainersSection />
            <HallsSection />
            <RulesSection />
            <Footer />
        </main>
    );
};

export default MainPage;
